import { useMutation, useQueryClient } from "@tanstack/react-query";
import { stergeTargetareContact } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useStergeTargetareContact() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: stergeTargetareContact,
    onSuccess: (_, variabile) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.firma(variabile.cui),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.contacteStats(),
      });
    },
  });
}
